export default __webpack_public_path__ + "static/media/landing_thumb_02.1862f574.svg";